import { __assign, __rest } from "tslib";
import React from 'react';
import { CardContent as MaterialCardContent, } from '@material-ui/core';
export var CardContent = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(MaterialCardContent, __assign({}, props), children);
};
//# sourceMappingURL=CardContent.js.map